<template>
  <div class="informasi_pendaftaran_free">
    <SOSlotBase
      :container-name="`informasi_pendaftaran_succses`"
      :loading="isLoading"
    >
      <template v-slot:title-bar>
        <SOTitleBar
          :page-title="'Detail Training'"
          :type="'back'"
          @back="back"
        />
      </template>
      <template v-slot:loading-page>
        <SOLoadingPage />
      </template>
      <template v-slot:content>
        <div class="p-x-20 p-t-16">
          <div
            class="form-control"
            style="
              display: flex;
              justify-content: space-between;
              background-color: #e8fcee;
              border: 1px solid #24a148;
            "
          >
            <div style="display: flex; justify-content: space-between">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM13.0893 8.92261C13.4147 8.59717 13.4147 8.06954 13.0893 7.7441C12.7638 7.41866 12.2362 7.41866 11.9107 7.7441L9.16667 10.4882L8.08926 9.41077C7.76382 9.08533 7.23618 9.08533 6.91074 9.41077C6.58531 9.73621 6.58531 10.2638 6.91074 10.5893L8.57741 12.2559C8.73369 12.4122 8.94565 12.5 9.16667 12.5C9.38768 12.5 9.59964 12.4122 9.75592 12.2559L13.0893 8.92261Z"
                  fill="#24A148"
                />
              </svg>
              <p class="f-14" style="margin-left: 5px">
                Jadwal berhasil diubah
              </p>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.52876 3.52864C3.78911 3.26829 4.21122 3.26829 4.47157 3.52864L8.00016 7.05723L11.5288 3.52864C11.7891 3.26829 12.2112 3.26829 12.4716 3.52864C12.7319 3.78899 12.7319 4.2111 12.4716 4.47145L8.94297 8.00004L12.4716 11.5286C12.7319 11.789 12.7319 12.2111 12.4716 12.4714C12.2112 12.7318 11.7891 12.7318 11.5288 12.4714L8.00016 8.94285L4.47157 12.4714C4.21122 12.7318 3.78911 12.7318 3.52876 12.4714C3.26841 12.2111 3.26841 11.789 3.52876 11.5286L7.05735 8.00004L3.52876 4.47145C3.26841 4.2111 3.26841 3.78899 3.52876 3.52864Z"
                fill="black"
              />
            </svg>
          </div>
        </div>
        <div class="p-t-16">
          <div
            class="f-Overpass p-x-20 d-flex-between-center"
            style="height: max-content"
            id="data_pesanan"
          >
            <p class="f-Overpass f-16 remove-margin" style="font-weight: 700">
              TFO241287241
            </p>
            <p class="f-Overpass f-c-midgrey remove-margin" id="status">
              Menunggu Konfirmasi CS
            </p>
          </div>
        </div>
        <div class="p-t-16"></div>
        <hr class="remove-margin" />
        <div class="p-x-20 p-y-16 bg-white">
          <div class="d-flex-between-center p-d-8">
            <div class="f-regular f-16 f-c-midgrey">Nama Program</div>
            <div class="f-regular f-16 f-c-black">Training Berbayar Online</div>
          </div>
          <div class="d-flex-between-center p-d-8">
            <div class="f-regular f-16 f-c-midgrey">Nama Owner</div>
            <div class="f-regular f-16 f-c-black">Lilu Lalita</div>
          </div>
          <div class="d-flex-between-center p-d-8">
            <div class="f-regular f-16 f-c-midgrey">No Telephone</div>
            <div class="f-regular f-16 f-c-black">+6282193749203</div>
          </div>
        </div>

        <div class="separator-line-dot p-d-8"></div>

        <h3 id="Detail">Jadwal Training</h3>

        <div class="p-x-20 bg-white">
          <label class="f-Overpass f-14 f-c-midgrey remove-margin"
            >Pertemuan ke 1</label
          >
          <div
            class="form-control"
            id="text_field"
            style="font-weight: bold; color: black; width: 100%"
          >
            4 Agustus 2023 11:00 - 13:00
          </div>
        </div>

        <div class="p-x-20 p-t-16 bg-white">
          <label class="f-Overpass f-14 f-c-midgrey remove-margin"
            >Pertemuan ke 2</label
          >
          <div
            class="form-control"
            id="text_field"
            style="font-weight: bold; color: black; width: 100%"
          >
            9 Agustus 2023 11:00 - 13:00
          </div>
        </div>

        <div class="btn_kembali p-x-20">
          <button
            type="button"
            class="btn btn-outline-primary btn-long p-t-8"
            id="buttonkembali"
            style="width: 100%"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M12.0398 1.99997C6.5798 1.99997 2.1298 6.44997 2.1298 11.91C2.1298 13.66 2.5898 15.36 3.4498 16.86L2.0498 22L7.2998 20.62C8.7498 21.41 10.3798 21.83 12.0398 21.83C17.4998 21.83 21.9498 17.38 21.9498 11.92C21.9498 9.26997 20.9198 6.77997 19.0498 4.90997C18.133 3.98389 17.041 3.24964 15.8374 2.75002C14.6339 2.2504 13.3429 1.99543 12.0398 1.99997ZM12.0498 3.66997C14.2498 3.66997 16.3098 4.52997 17.8698 6.08997C18.6354 6.85532 19.2424 7.76428 19.656 8.76473C20.0695 9.76517 20.2815 10.8374 20.2798 11.92C20.2798 16.46 16.5798 20.15 12.0398 20.15C10.5598 20.15 9.1098 19.76 7.8498 19L7.5498 18.83L4.4298 19.65L5.2598 16.61L5.0598 16.29C4.23374 14.9786 3.79682 13.4598 3.7998 11.91C3.8098 7.36997 7.4998 3.66997 12.0498 3.66997ZM8.5298 7.32997C8.3698 7.32997 8.0998 7.38997 7.8698 7.63997C7.6498 7.88997 6.9998 8.49997 6.9998 9.70997C6.9998 10.93 7.8898 12.1 7.9998 12.27C8.1398 12.44 9.7598 14.94 12.2498 16C12.8398 16.27 13.2998 16.42 13.6598 16.53C14.2498 16.72 14.7898 16.69 15.2198 16.63C15.6998 16.56 16.6798 16.03 16.8898 15.45C17.0998 14.87 17.0998 14.38 17.0398 14.27C16.9698 14.17 16.8098 14.11 16.5598 14C16.3098 13.86 15.0898 13.26 14.8698 13.18C14.6398 13.1 14.4998 13.06 14.3098 13.3C14.1498 13.55 13.6698 14.11 13.5298 14.27C13.3798 14.44 13.2398 14.46 12.9998 14.34C12.7398 14.21 11.9398 13.95 10.9998 13.11C10.2598 12.45 9.7698 11.64 9.6198 11.39C9.4998 11.15 9.6098 11 9.7298 10.89C9.8398 10.78 9.9998 10.6 10.0998 10.45C10.2298 10.31 10.2698 10.2 10.3498 10.04C10.4298 9.86997 10.3898 9.72997 10.3298 9.60997C10.2698 9.49997 9.7698 8.25997 9.5598 7.76997C9.3598 7.28997 9.1598 7.34997 8.9998 7.33997C8.8598 7.33997 8.6998 7.32997 8.5298 7.32997Z"
                fill="#206CFE"
              />
            </svg>
            Hubungi CS
          </button>
        </div>
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase.vue";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar.vue";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";

export default {
  name: "detailTraining_WaitConfirmCS_ResceduleSucses_TrainingOnline",
  components: {
    SOTitleBar: SOTitleBar,
    SOSlotBase: SOSlotBase,
    SOLoadingPage: SOLoadingPage,
  },

  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
#Detail {
  font-family: Overpass;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.32px;
  margin-left: 20px;
  margin-top: 10px;
}

.btn_kembali {
  margin-top: 8%;
}
#buttonkembali {
  font-weight: 600;
}

#status {
  text-align: center;
  background-color: #fff8e1;
  font-size: 11px;
  border-radius: 3px;
  width: max-content;
  padding: 2px;
}
@media (min-width: 320px) and (max-width: 768px) {
  .btn_kembali {
    margin-top: 20%;
  }
}
</style>
